export interface IMinimalPriceContainer {
    minimalPrice: IMinimalPrice;
    comparisonPrice: IComparisonPrice;
    discountPrice: IDiscountPrice;
    quantityUnitPlural: string;
}

export interface IFlexibleSetPriceContainer {
    discountType: string;
    originalPrice: IFlexSetPrice;
    price: IFlexSetPrice;
}

export interface IMinimalPrice {
    price: IPrice;
    quantity: number;
    priceType: PriceEnum;
}

export enum PriceEnum {
    Only = "only",
    From = "from"
}

export interface IComparisonPrice {
    price: IPrice;
    unit: string;
}

export interface IDiscountPrice {
    originalPrice: IPrice;
}

export interface IPrice {
    netValue: string;
    grossValue: string;
}

export interface IFlexSetPrice {
    netValue: number;
    grossValue: number;
}

export interface IPriceMandantSettings {
    currencySymbolWeb: string;
    currencySymbolMobile: string;
    prependCurrencySymbolWeb: boolean;
    prependCurrencySymbolMobile: boolean;
}

export interface IArticlePriceProps {
    prices: IMinimalPriceContainer;
    priceSettings: IPriceMandantSettings;
}

export interface IFlexibleSetPriceProps {
    prices: IFlexibleSetPriceContainer;
    priceSettingsV2: IPriceMandantSettingsV2;
}

export interface IPriceMandantSettingsV2 {
    numberDecimalDigits: number;
    numberGroupSizes: number;
    numberDecimalSeparator: string;
    numberGroupSeparator: string;
    currencySymbol: string;
    prependCurrencySymbol: boolean;
}
